import React from "react";
import styled from "styled-components";
import PlusIcon from "assets/images/plus.svg?react";

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  margin-top: 9px;
  padding: 4px 12px 4px 0;
  column-gap: 18px;
`;

const Text = styled.div`
  font-weight: 400;
  font-size: 11px;
  line-height: 15px;
  text-transform: uppercase;
  color: ${props => props.theme.gridSectionAddActionColor};
  cursor: pointer;
  padding: 4px 0;
`;

const PlusAddIcon = styled(PlusIcon)`
  margin-right: 4px;
  width: 8px;
`;

const NewAction = ({ onClick = () => null, isReadOnly = false, newActionContextMenuItems = null }) => {
  if (!isReadOnly && Array.isArray(newActionContextMenuItems) && newActionContextMenuItems.length > 0) {
    return (
      <Wrapper onClick={onClick}>
        {newActionContextMenuItems.map((item, index) => (
          <Text key={index} onClick={() => onClick(item)}>
            <PlusAddIcon />
            {item.label}
          </Text>
        ))}
      </Wrapper>
    );
  }

  return null;
};

export default NewAction;
